import React from 'react';
import { twMerge } from 'tailwind-merge';
interface StatCardProps {
  title: string;
  value: string | number;
  icon: React.ReactNode;
  trend?: {
    value: string;
    isPositive: boolean;
  };
  className?: string;
}
export function StatCard({
  title,
  value,
  icon,
  trend,
  className
}: StatCardProps) {
  return <div className={twMerge('bg-white rounded-xl border border-slate-200 p-6 shadow-sm', className)} data-id="element-282" data-mp="jkclxgvgfrlv">
      <div className="flex items-center justify-between mb-4" data-id="element-283" data-mp="ek6v22x0e94u">
        <h3 className="text-sm font-medium text-slate-500" data-id="element-284" data-mp="ajwp2q97vipz">{title}</h3>
        <div className="p-2 bg-slate-50 rounded-lg text-slate-600" data-id="element-285" data-mp="5l398r6gjfmn">{icon}</div>
      </div>
      <div className="flex items-baseline gap-2" data-id="element-286" data-mp="mrz0fc9333w">
        <span className="text-3xl font-bold text-slate-900" data-id="element-287" data-mp="o35imx2yoyp">{value}</span>
        {trend && <span className={twMerge('text-sm font-medium', trend.isPositive ? 'text-emerald-600' : 'text-red-600')} data-id="element-288" data-mp="1zz48hd5x64n9">
            {trend.isPositive ? '+' : '-'}
            {trend.value}
          </span>}
      </div>
    </div>;
}